import { compact, invert, isArray } from 'lodash';

import { sanitizeQuery } from '@app/components';
import { removeQuotes } from '@app/utils';

import {
  ADVANCED_SEARCH_FIELD,
  ADVANCED_SEARCH_QUALIFIER,
  FIELDS_REGEX,
  FIELDS_TO_MASK_MAP,
  QUALIFIERS_REGEX,
  RowValues,
  SEARCH_QUALIFIER_MASK_MAP,
} from '../constants';

export const parseMaskedFieldQualifierValue = (
  fieldQualifierValue: string
): RowValues => {
  const regex = new RegExp(`^(${FIELDS_REGEX}) (${QUALIFIERS_REGEX}) (".*")$`);
  const isQueryStringValid = regex.test(fieldQualifierValue.trim());

  if (!isQueryStringValid) {
    return {
      field: ADVANCED_SEARCH_FIELD.keywordAnywhere,
      qualifier: ADVANCED_SEARCH_QUALIFIER.containsAll,
      value: fieldQualifierValue,
      isInvalid: true,
    };
  }

  const [field, qualifier, ...query] = compact(
    fieldQualifierValue.trim().split(regex)
  );
  const value = sanitizeQuery(
    removeQuotes(isArray(query) ? query.join('') : query)
  );

  return {
    field: invert(FIELDS_TO_MASK_MAP)[field] as ADVANCED_SEARCH_FIELD,
    qualifier: invert(SEARCH_QUALIFIER_MASK_MAP)[
      qualifier
    ] as ADVANCED_SEARCH_QUALIFIER,
    value,
  };
};
